import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../API";
import NavBar from "../Navbar";
import { Helmet } from "react-helmet-async";
import "./CategoryContent.css";

// 🔹 SkeletonCard for loading
const SkeletonCard = () => (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
        <div className="card shadow-sm h-100 placeholder-glow">
            <div className="placeholder w-100" style={{ height: "200px", backgroundColor: "#e0e0e0" }}></div>
            <div className="card-body">
                <div className="placeholder col-8 mb-2" style={{ height: "1.2rem" }}></div>
                <div className="placeholder col-6" style={{ height: "1rem" }}></div>
            </div>
        </div>
    </div>
);

const SubchannelDetails = () => {
    const location = useLocation();
    // const MainchannelName = location.pathname.split("/")[1];
    // const fullSlug = location.pathname.split("//")[1]; // e.g. "cvack-fjfj-234"

    const pathParts = location.pathname.split("/").filter(Boolean);

    // Example: /fosl/faruv → ["fosl", "faruv"]
    const MainchannelName = pathParts[0] || "";   // fosl
    const fullSlug = pathParts[2] || "";    // /channel/faruv


    const subchannelName = fullSlug || ""; // Full slug string

    const [subchannel, setSubchannel] = useState({});
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9;
    const totalPages = Math.ceil(videos.length / itemsPerPage);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${API}/api/lesson/subchannel/${subchannelName}`);
                setSubchannel(res.data?.subchannel || {});
                setVideos(res.data?.data || []);
            } catch (err) {
                console.error("Error fetching subchannel data:", err);
            } finally {
                setLoading(false);
            }
        };

        if (subchannelName) fetchData();
    }, [subchannelName]);

    const getPaginatedVideos = () => {
        const start = (currentPage - 1) * itemsPerPage;
        return videos.slice(start, start + itemsPerPage);
    };

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) setCurrentPage(page);
    };

    const generateSlug = (title, id) =>
        `${title?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${id}`;

    const generateChannelSlug = (name, id) =>
        `${name.replace(/[^a-z0-9]+/g, "-")}-${id}`;

    const slugify = (text = "") =>
        `${MainchannelName}/channel/${text?.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;
    return (
        <>
            <Helmet>
                <title>
                    {subchannel?.name
                        ? `${subchannel.name} - Channel | Watch Now`
                        : "Explore Channel"}
                </title>
                <meta
                    name="description"
                    content={`Watch exclusive content from subchannel ${subchannel?.name || ""}`}
                />
            </Helmet>

            <NavBar
                categoryLogo={subchannel?.logo?.url}
                categoryId={slugify(subchannelName)}

            />

            <div className="px-3 px-md-5 px-lg-7">
                {loading ? (
                    <div className="row">
                        {Array.from({ length: 8 }).map((_, index) => (
                            <SkeletonCard key={index} />
                        ))}
                    </div>
                ) : (
                    <>
                        {subchannel?.banner?.url && (
                            <div className="subchannel-banner mb-4">
                                <img
                                    src={subchannel.banner.url}
                                    alt={subchannel.name}
                                    className="img-fluid w-100 rounded"
                                />
                            </div>
                        )}

                        {subchannel?.parentChannel && (
                            <div className="d-flex justify-content-center mb-4">
                                <Link
                                    to={`/channel/${generateChannelSlug(
                                        subchannel.parentChannel.name,
                                        subchannel.parentChannel._id
                                    )}`}
                                    className="parent-channel-link d-flex align-items-center"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    {subchannel?.parentChannel?.logo?.url && (
                                        <img
                                            src={subchannel.parentChannel.logo.url}
                                            alt={subchannel.parentChannel.name}
                                            className="rounded-circle me-2"
                                            style={{ width: "40px", height: "40px", objectFit: "cover" }}
                                        />
                                    )}
                                </Link>
                            </div>
                        )}

                        <div className="row">
                            {videos.length > 0 && <h3 className="fw-bold">View Videos</h3>}
                            {videos.length > 0 ? (
                                getPaginatedVideos().map((video) => (
                                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={video._id}>
                                        <Link

                                            to={
                                                subchannel
                                                    ? `/${slugify(subchannelName)}/${generateSlug(video.title, video._id)}`
                                                    : `/${MainchannelName}/${generateSlug(video.title, video._id)}`
                                            }

                                            // to={`/view/${generateSlug(video.title, video._id)}`}



                                            className="content-card-link">
                                            <div className="card shadow-sm video-card">
                                                <img
                                                    src={video.thumbnail}
                                                    alt={video.title}
                                                    className="card-img-top"
                                                    style={{ objectFit: "cover", height: "200px" }}
                                                />
                                                <div className="card-body">
                                                    <h5 className="card-title text-center">{video.title}</h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                <div
                                    className="col-12 d-flex align-items-center justify-content-center"
                                    style={{ minHeight: "300px" }}
                                >
                                    <div className="text-center">
                                        <h4 className="text-muted">No videos available</h4>
                                        <p className="text-muted">Please check back later.</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        {videos.length > itemsPerPage && (
                            <nav>
                                <ul className="pagination justify-content-center">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, i) => (
                                        <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                                            <button className="page-link" onClick={() => handlePageChange(i + 1)}>
                                                {i + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default SubchannelDetails;
